import styled from 'styled-components';

export const TableCaptionStyled = styled.caption`
  color: #000;
  font-weight: 700;
`;
